<template>
  <v-layout row wrap>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]" class="mt-3">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.intermediaries" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.products" v-model="filters.product" :label="filtersLabel.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="filtersLabel.product" :error-messages="errors.collect('product')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.busClses" v-model="filters.busCls" :label="filtersLabel.busCls" item-text="label" item-value="value" data-vv-name="busCls" :data-vv-as="filtersLabel.busCls" :error-messages="errors.collect('busCls')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.covers" v-model="filters.cover" :label="filtersLabel.cover" item-text="label" item-value="value" data-vv-name="cover" :data-vv-as="filtersLabel.cover" :error-messages="errors.collect('cover')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.appName" :label="filtersLabel.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="filtersLabel.appName" v-validate="'name|max:60'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-uppercase="filters.vehRegNo" v-model="filters.vehRegNo" :label="filtersLabel.vehRegNo" :error-messages="errors.collect('vehRegNo')" data-vv-name="vehRegNo" :data-vv-as="filtersLabel.vehRegNo" v-validate="'veh_reg_no'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.polNo" :label="filtersLabel.polNo" :error-messages="errors.collect('polNo')" data-vv-name="polNo" :data-vv-as="filtersLabel.polNo" v-validate="'entry|max:16'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <transition name="slide-x-transition" mode="out-in">
                    <v-layout row wrap v-if="showDetailFilters">
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.appNricPassport" :label="filtersLabel.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="filtersLabel.appNricPassport" v-validate="'alpha_num|max:60'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.coyName" :label="filtersLabel.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="filtersLabel.coyName" v-validate="'name|max:60'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.usrRefId" :label="filtersLabel.usrRefId" :error-messages="errors.collect('usrRefId')" data-vv-name="usrRefId" :data-vv-as="filtersLabel.usrRefId" v-validate="'entry|max:60'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6></v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </transition>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-data-table :headers="listHeaders" :items="items" item-key="proposalNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" :rows-per-page-items="itemsPerPage" :no-data-text="'No Proposals Posted Today.'">
        <template slot="items" slot-scope="props">
          <td v-for="column in selectedColumns" :key="column">
            {{props.item[column]}}
          </td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import clone from 'clone'
import { postingMixin } from '../shared/postingMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import toDate from 'date-fns/toDate'
import { removeTime, setEndTime, formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      columns: [
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Intermediary', value: 'intermediary' },
        { text: 'Product', value: 'product' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Cover', value: 'cover' },
        { text: 'Premium', value: 'premium' },
        { text: 'Applicant Name', value: 'appName' },
        { text: 'Company Name', value: 'coyName' },
        { text: 'Registration No.', value: 'vehRegNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'NRIC/Passport', value: 'appNricPassport' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'User Ref Id', value: 'usrRefId' }
      ],
      selectedColumns: ['proposalNo', 'polNo', 'vehRegNo', 'cover', 'premium', 'appName', 'createdDate'],
      filtersLabel: {
        proposalNo: 'Proposal No.',
        intermediary: 'Intermediary',
        product: 'Product',
        busCls: 'Business Class',
        cover: 'Cover Type',
        appName: 'Applicant Name',
        coyName: 'Company Name',
        vehRegNo: 'Registration No.',
        polNo: 'Policy No.',
        appNricPassport: 'NRIC/Passport',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To',
        usrRefId: 'User Ref Id'
      },
      filters: {
        proposalNo: null,
        intermediary: null,
        product: null,
        busCls: null,
        cover: null,
        appName: null,
        coyName: null,
        vehRegNo: null,
        polNo: null,
        appNricPassport: null,
        entryFrom: null,
        entryTo: null,
        usrRefId: null
      },
      params: {
        intermediaries: [],
        products: [],
        busClses: [],
        covers: []
      },
      showDetailFilters: false
    }
  },
  methods: {
    async fetchData(options) {
      if (this.apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage,
            options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))

          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((quote) => {
                const convertQuote = {
                  proposalNo: quote.proposalNo,
                  intermediary: quote.intermediaryName,
                  product: quote.productName,
                  busCls: quote.busClsName,
                  cover: quote.cvrTypeName,
                  premium: this.formatNumber(quote.premium),
                  appName: quote.appName,
                  coyName: quote.coyName,
                  vehRegNo: quote.vehRegNo,
                  polNo: quote.polNo,
                  appNricPassport: quote.appNricPassport,
                  createdDate: this.formatDate(toDate(quote.createdDate)),
                  usrRefId: quote.usrRefId
                }
                this.items.push(convertQuote)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$set(this.params, 'intermediaries', result.data.intermediaries)
              this.$set(this.params, 'products', result.data.products)
              this.$set(this.params, 'busClses', result.data.busClses)
              this.$set(this.params, 'covers', result.data.covers)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.proposalNo = null
      this.filters.intermediary = null
      this.filters.product = null
      this.filters.busCls = null
      this.filters.cover = null
      this.filters.appName = null
      this.filters.coyName = null
      this.filters.vehRegNo = null
      this.filters.polNo = null
      this.filters.appNricPassport = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.filters.usrRefId = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  watch: {
    'value': function (value) {
      if (value) {
        this.fetchData(false)
      } else {
        this.$emit('input', false)
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.apiUrl = this.postingState.menu.motorPosted
  },
  mixins: [
    postingMixin
  ]
}
</script>

<style lang="scss">
</style>
